<h2 mat-dialog-title>{{ 'FRONTEND.SALES_UI.PIPELINE.STATUS_TITLE' | translate }}</h2>

<mat-dialog-content>
  <glxy-checkbox
    [formControl]="statuses.get('open')"
    label="{{ 'FRONTEND.SALES_OPPORTUNITIES.OPEN' | translate }}"
  ></glxy-checkbox>
  <glxy-checkbox
    [formControl]="statuses.get('won')"
    label="{{ 'FRONTEND.SALES_OPPORTUNITIES.CLOSED_WON' | translate }}"
  ></glxy-checkbox>
  <glxy-checkbox
    [formControl]="statuses.get('lost')"
    label="{{ 'FRONTEND.SALES_OPPORTUNITIES.CLOSED_LOST' | translate }}"
  ></glxy-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button color="primary" mat-button mat-dialog-close>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button (click)="save(statuses)" color="primary" mat-raised-button>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
